import { useCallback } from 'react';
import { useGetStreamingPlaySourcesQuery } from '../../../../redux/api/fymAPI';

/** Streaming → Play sources (design streaming-sections b1, b2): the months of one source and store. */
export function useStreamingPlaySources(input: {
  accountId: number;
  days: number;
  source: string | undefined;
  skip: boolean;
}) {
  const { accountId, days, source, skip } = input;
  const read = useGetStreamingPlaySourcesQuery({ accountId, days, source }, { skip });
  const { refetch } = read;
  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
  return { data: read.data, isLoading: read.isLoading, error: read.error, retry };
}
